module.exports = __webpack_public_path__ + "img/modelo_rio.a045c78b.png";